import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {formatDate} from "@angular/common";

@Pipe({
  name: 'dateLocale'
})
export class DateLocalePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}
  allowedLocales: string[] = ['en-GB', 'en-US', 'de-DE'];

  transform(value: any, format?: string) {
    if (!value) { return ''; }
    if (!format) { format = 'shortDate'; }
    if (this.translate.defaultLang) {
      //console.log('translate defaultLang', this.translate.defaultLang);
      if (this.isAllowLocale(this.translate.defaultLang)) {
         return formatDate(value, format, this.translate.defaultLang);
      } else {
         return formatDate(value, format, 'en-GB');
      }
    } else {
      return formatDate(value, format, 'en-GB');
    }


  }
  isAllowLocale(value: any): boolean {
   // console.log('isAllowLocale', value);
    for (const loc of this.allowedLocales) {
      if (loc === value) {
        return true;
      }
    }
    return false;
  }

}
